import React from 'react';
import PropTypes from 'prop-types';

export const Svg = ({ size, colour, type, rotation, ...otherProps }) => {
  return (
    <div className="mz-svg-wrapper" {...otherProps}>
      <i
        style={{ fontSize: size + 'rem' }}
        className={[
          'mz-svg',
          colour ? `mz-svg--${colour}` : '',
          type ? `mz-svg-${type}` : '',
          rotation ? `mz-svg--rotate${rotation}` : '',
        ].join(' ')}></i>
    </div>
  );
};

Svg.propTypes = {
  size: PropTypes.number,
  colour: PropTypes.string,
  type: PropTypes.string.isRequired,
  rotation: PropTypes.string,
}